<template>
  <div>
    <div ref="form">
      <!-- Row Loop -->
      <b-row
        v-for="(remolque, index) in remolques"
        :id="index"
        :key="index"
        ref="row"
      >
        <!-- Item Name -->
        <b-col cols="10">
          <Remolque :remolque="remolque" :index="index" />
        </b-col>

        <!-- Remove Button -->
        <b-col v-if="remolques.length > min" cols="2">
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="outline-danger"
            class="mt-0 mt-md-2"
            @click="removeItem(index)"
          >
            <feather-icon icon="XIcon" class="mr-25" />
            <span>Borrar</span>
          </b-button>
        </b-col>
        <b-col cols="12">
          <hr />
        </b-col>
      </b-row>

      <b-button
        v-if="remolques.length < 2"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="secondary"
        @click="addItem"
      >
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span>Agregar remolque</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import Remolque from '@/views/CartaPorte/Remolque'

export default {
  components: {
    Remolque,
    BRow,
    BCol,
    BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    remolques: {
      type: Array,
      default: null,
    },
    min: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      nextRowId: 0,
    }
  },
  computed: {},
  mounted() {
    this.initTrHeight()
    this.nextRowId = this.remolques.length
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
    this.addItem()
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    addItem() {
      this.remolques.push({
        '@SubTipoRem': '',
        '@Placa': '',
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      if (this.remolques.length > this.min) {
        this.remolques.splice(index, 1)
        this.trTrimHeight(this.$refs.row[0].offsetHeight)
      }
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select.scss';
</style>
